import { render, staticRenderFns } from "./cdsInvitation.vue?vue&type=template&id=62679514&scoped=true"
import script from "./cdsInvitation.vue?vue&type=script&lang=js"
export * from "./cdsInvitation.vue?vue&type=script&lang=js"
import style0 from "./cdsInvitation.vue?vue&type=style&index=0&id=62679514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62679514",
  null
  
)

export default component.exports